import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import CalendarView from '../CalendarView/CalendarView';
import SubprocessPopup from '../../Components/SubprocessPopup/SubprocessPopup';
import AltaCentroPopup from '../../Components/AltaCentroPopup/AltaCentroPopup';
import { GlobalContext } from '../../Context/GlobalContext';
import ProcessPopup from '../../Components/ProcessPopup/ProcessPopup';
import AddTaskPopup from '../../Components/AddTaskPopup/AddTaskPopup';
import SelectTaskPopup from '../../Components/SelectTaskPopup/SelectTaskPopup';
import AlertDialog from '../../Components/AlertDialog/AlertDialog';
import ProcessView from '../ProcessView/ProcessView';
import ReportsView from '../ReportsView/ReportsView';
import Settings from '../Settings/Settings';


const Files = () => <Typography variant="h4">Files</Typography>;
const Messages = () => <Typography variant="h4">Messages</Typography>;
//const Settings = () => <Typography variant="h4">Settings</Typography>;

/**
 * The main content area of the application. It handles routing and displays the appropriate
 * component based on the current URL path. It also conditionally renders various popup
 * components (e.g., SubprocessPopup, ProcessPopup) based on the state from the GlobalContext.
 *
 * @component
 * @returns {JSX.Element} - The main content area with routing and conditional popups.
 *
 * @example
 * return (
 *   <Content />
 * );
 */
const Content = () => {
  
  const {altaCentroModalOpen, modalOpen, processModalOpen, newTaskOpen, selectTaskOpen, alertOpen} = React.useContext(GlobalContext);
  return (
    <>
      <div style={{ flexGrow: 1, padding: '16px', height: "83vh", marginLeft: "250px"}}>
        <Routes>
          <Route path="/" element={<Navigate to="/calendar" />} />
          <Route path="/oauth2/idpresponse" element={<Navigate to="/calendar" />} />
          <Route path="/calendar" element={<CalendarView />} />
          <Route path="/processes" element={<ProcessView />} />
          <Route path="/files" element={<Files />} />
          <Route path="/reports" element={<ReportsView />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
        {modalOpen && <SubprocessPopup/>}
        {altaCentroModalOpen && <AltaCentroPopup/>}
        {processModalOpen && <ProcessPopup/>}
        {selectTaskOpen && <SelectTaskPopup/>}
        {newTaskOpen && <AddTaskPopup/>}
        {alertOpen && <AlertDialog/>}
      </div>
    </>
  );
};

export default Content;
